/* eslint-disable jsx-a11y/label-has-associated-control */
import { IconInfoFilled } from '@prisjakt/ui/icon';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { MultiRadioProps, Variants } from '.';
import { Inputs, MultiRadio, RadioDot, ScaleRadio, Error } from './styles';

export interface IOptions {
  value: number;
  label: string;
}

type ScaleFormProps = Omit<MultiRadioProps, 'options' | 'variant'> & {
  options: IOptions[];
};

export const ScaleForm = ({
  currentValue,
  disabledOptions,
  labels = [],
  name,
  onClick,
  options,
  optionValues = [],
  required,
  disabled = false,
}: ScaleFormProps) => {
  const { t } = useContext(AppContext);
  const [error, setError] = useState<string | null>();
  const [checked, setChecked] = useState(currentValue);

  useEffect(() => {
    setChecked(null);
  }, [name]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      return;
    }

    if (e.target.checkValidity()) {
      setError(null);
    }

    if (onClick) {
      onClick(e);
    }

    setChecked(parseInt(e.target.value, 10));
  };

  const handleInvalidity = (e: React.InvalidEvent<HTMLInputElement>) => {
    if (error === e.target.name) {
      return;
    }

    setError(e.target.name);
  };

  const renderOptions = () =>
    options.map((option, index) => {
      const fieldId: string = `${name}:${option.value.toString()}`;
      return (
        <Fragment key={fieldId}>
          <ScaleRadio
            type="radio"
            name={name}
            id={fieldId}
            value={option.value}
            required={required}
            onChange={handleChange}
            alignRight={index + 1 === options.length}
            alignLeft={index === 0}
            showError={error === name}
            tabIndex={0}
            checked={checked === option.value}
          />
          <label
            htmlFor={fieldId}
            data-label={option.label.length > 0 ? option.label : null}
          >
            <RadioDot />
          </label>
        </Fragment>
      );
    });

  return (
    <>
      <MultiRadio
        variant={Variants.scale}
        hasSelected={Boolean(optionValues.length)}
        showError={error === name}
        onInvalid={handleInvalidity}
      >
        <Inputs>{renderOptions()}</Inputs>
      </MultiRadio>

      {name && error === name && (
        <Error>
          <IconInfoFilled size={16} color="negative700" />{' '}
          {t('reviews', 'form.error-radio')}
        </Error>
      )}
    </>
  );
};
